import { useMemo } from 'react';
import { useFragment } from '@apollo/client';
import type { AccountRoleInfoFragment } from '@frameio/graphql-client/generated';
import { AccountRoleInfo } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '../../contexts';

export function useAccountRoleTracking(
  options: { includeRoleName: boolean } = { includeRoleName: false }
) {
  const accountId = useActiveAccountId() ?? '';
  const { data } = useFragment<AccountRoleInfoFragment>({
    fragment: AccountRoleInfo,
    fragmentName: 'AccountRoleInfo',
    from: {
      __typename: 'Account',
      id: accountId,
    },
  });
  const currentAccountRoleTracking = useMemo(() => {
    const accountRole = data.role?.id;

    if (!accountRole) {
      return undefined;
    }

    const roleName = data.role?.name;

    if (options.includeRoleName && roleName) {
      return {
        account_role: accountRole,
        name: roleName.replaceAll(' ', ''),
      };
    }

    return { account_role: accountRole };
  }, [data, options?.includeRoleName]);

  return currentAccountRoleTracking;
}
